import { chakra } from '@chakra-ui/react'
import { SVGProps } from 'react'

export const EmptyAllocationsCardSvg = chakra(
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      width="451"
      height="276"
      viewBox="0 0 451 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M111.128 84.0067H51.039C36.943 84.0067 25.5164 92.267 25.5164 102.456V258.645C25.5164 268.834 36.943 277.094 51.039 277.094H111.128C125.224 277.094 136.652 268.834 136.652 258.645V102.456C136.652 92.267 125.224 84.0067 111.128 84.0067Z"
        fill="#FFEEC1"
      />
      <path
        d="M263.131 181.923H189.741C174.347 181.923 169.634 190.623 169.634 195.661V268.276C169.634 273.314 182.113 277.398 197.508 277.398H263.131C278.526 277.398 291.006 273.314 291.006 268.276V191.046C291.006 186.008 278.526 181.923 263.131 181.923Z"
        fill="#FFEEC1"
      />
      <path
        d="M190.917 207.755L214.96 197.89L235.908 193.209L269.068 200.274L277.83 276.912H180.886V223.86L190.917 207.755Z"
        fill="#3A3A94"
      />
      <path
        d="M209.825 162.062C209.825 160.94 209.644 159.885 209.326 158.963V155.489H205.598C203.264 155.489 201.37 158.431 201.37 162.065C201.37 165.698 203.264 168.641 205.598 168.641H209.326V165.167C209.644 164.244 209.825 163.187 209.825 162.067V162.062Z"
        fill="#3A3A94"
      />
      <path
        d="M209.324 168.638C211.658 168.638 213.551 165.694 213.551 162.062C213.551 158.43 211.658 155.486 209.324 155.486C206.989 155.486 205.096 158.43 205.096 162.062C205.096 165.694 206.989 168.638 209.324 168.638Z"
        fill="white"
      />
      <path
        d="M209.326 166.182C210.788 166.182 211.974 164.337 211.974 162.062C211.974 159.787 210.788 157.943 209.326 157.943C207.863 157.943 206.677 159.787 206.677 162.062C206.677 164.337 207.863 166.182 209.326 166.182Z"
        fill="#3A3A94"
      />
      <path
        d="M199.511 242.01C209.797 242.01 218.135 233.885 218.135 223.861C218.135 213.837 209.797 205.711 199.511 205.711C189.224 205.711 180.886 213.837 180.886 223.861C180.886 233.885 189.224 242.01 199.511 242.01Z"
        fill="#3A3A94"
      />
      <path
        d="M211.523 169.831C211.523 169.831 216.145 192.193 214.656 202.342C213.169 212.492 224.178 212.203 224.178 212.203C224.178 212.203 245.605 211.913 236.379 194.804C236.379 194.804 230.816 177.268 231.185 166.537L211.523 169.831Z"
        fill="#FFCBCB"
      />
      <path
        d="M213.55 182.733C213.55 182.733 214.566 189.224 214.768 192.728L218 190.843L221.252 188.945C225.055 186.155 226.025 182.88 225.892 177.05L225.779 172.005L213.55 182.733Z"
        fill="#151E4D"
      />
      <path
        d="M219.281 182.997C214.04 185.491 207.56 185.162 206.977 179.167C206.081 169.968 205.265 159.219 205.756 154.294C206.7 144.806 220.79 148.781 220.79 148.781C220.79 148.781 232.59 164.055 231.367 169.391C229.228 178.716 219.281 182.995 219.281 182.995V182.997Z"
        fill="#FFCBCB"
      />
      <path
        d="M231.485 167.914C230.886 164.977 230.448 162.216 229.33 159.398C227.784 155.523 225.962 151.528 223.843 147.92C222.559 145.73 219.155 144.832 216.591 145.164C210.9 145.9 201.385 147.693 201.073 151.496C200.628 156.934 207.12 158.74 210.859 152.531C212.443 149.9 214.83 151.319 216.448 153.092C218.899 155.78 219.836 158.625 220.877 162.004C221.105 162.742 221.361 163.523 221.965 164.019C223.196 165.027 224.207 164.022 224.127 162.797C224.012 161.044 223.216 159.107 222.551 157.493C222.298 156.875 222.016 156.256 221.95 155.593C221.883 154.932 222.07 154.204 222.602 153.787C222.625 153.77 224.941 158.735 225.136 159.196C226.272 161.92 227.848 164.408 229.156 167.037C229.304 167.336 229.453 167.635 229.601 167.934C229.944 168.623 230.292 169.318 230.781 169.919C230.968 170.149 231.28 170.381 231.541 170.236C231.766 170.109 231.769 169.797 231.74 169.545C231.679 168.992 231.592 168.451 231.482 167.914H231.485Z"
        fill="#151E4D"
      />
      <path
        d="M211.748 157.988C211.968 158.619 211.817 159.239 211.41 159.374C211.003 159.509 210.496 159.107 210.274 158.476C210.054 157.845 210.205 157.225 210.612 157.09C211.018 156.955 211.525 157.357 211.748 157.988Z"
        fill="#151E4D"
      />
      <path
        d="M206.567 159.557C206.375 159.226 205.874 159.258 205.733 159.615C205.733 159.615 204.666 161.926 203.581 166.649C203.394 167.457 204.162 168.136 204.896 167.719L207.895 166.023C208.955 165.425 209.323 164.108 208.724 163.068L206.567 159.557Z"
        fill="#EB8D90"
      />
      <path
        d="M243.435 276.909H193.027V269.976H246.866V273.564C246.866 275.41 245.328 276.909 243.435 276.909Z"
        fill="#151E4D"
      />
      <path
        d="M136.589 276.912H216.172L199.631 234.226C198.129 230.348 194.318 227.782 190.065 227.782H129.707C123.832 227.782 119.768 233.508 121.846 238.867L136.591 276.914L136.589 276.912Z"
        fill="#151E4D"
      />
      <path
        d="M130.159 245.761L128.962 246.201L130.536 250.261L131.733 249.82L130.159 245.761Z"
        fill="white"
      />
      <path
        d="M209.382 274.82L194.972 237.633C193.764 234.516 190.654 232.421 187.236 232.421H131.049C129.652 232.421 128.395 233.062 127.602 234.182C126.809 235.301 126.635 236.673 127.129 237.947L129.222 243.346L128.024 243.787L125.931 238.388C125.296 236.75 125.527 234.915 126.548 233.473C127.569 232.034 129.25 231.174 131.047 231.174H187.233C191.182 231.174 194.772 233.593 196.167 237.191L210.577 274.378L209.379 274.82H209.382Z"
        fill="white"
      />
      <path
        d="M171.42 255.026C172.478 252.775 171.464 250.116 169.155 249.085C166.846 248.055 164.116 249.043 163.059 251.293C162.001 253.543 163.016 256.203 165.325 257.234C167.634 258.264 170.363 257.276 171.42 255.026Z"
        fill="white"
      />
      <path
        d="M281.594 209.781L299.843 252.112C304.244 262.321 296.14 273.493 284.793 272.855L244.726 273.109C240.755 273.134 236.896 271.835 233.789 269.426L233.738 269.386L226.47 273.346C224.2 273.573 223.12 272.478 224.241 270.541C224.576 269.962 225.063 269.326 225.748 268.636C225.748 268.636 222.189 274.855 219.868 271.182C219.868 271.182 215.556 270.927 220.781 262.905L225.615 259.084L219.604 262.269C219.604 262.269 218.035 267.618 215.162 268.636C212.288 269.655 213.462 261.376 216.208 259.212C217.759 257.987 221.232 255.91 223.96 254.334C226.355 252.95 229.142 252.351 231.911 252.631L245.481 253.992L264.979 253.229L250.116 228.923L281.594 209.783V209.781Z"
        fill="#FFCBCB"
      />
      <path
        d="M222.114 153.684C222.114 153.684 221.274 143.442 210.455 146.28C210.455 146.28 212.118 145.031 214.669 144.652C218.055 144.148 221.356 146.016 222.659 149.103C223.094 150.138 223.57 151.457 224.051 153.131L222.114 153.684Z"
        fill="white"
      />
      <path
        d="M228.781 157.804C228.781 156.682 228.599 155.627 228.282 154.704V151.23H224.553C222.219 151.23 220.326 154.173 220.326 157.806C220.326 161.44 222.219 164.383 224.553 164.383H228.282V160.909C228.599 159.986 228.781 158.929 228.781 157.809V157.804Z"
        fill="#3A3A94"
      />
      <path
        d="M228.279 164.38C230.614 164.38 232.507 161.435 232.507 157.804C232.507 154.172 230.614 151.228 228.279 151.228C225.944 151.228 224.052 154.172 224.052 157.804C224.052 161.435 225.944 164.38 228.279 164.38Z"
        fill="white"
      />
      <path
        d="M228.288 161.924C229.751 161.924 230.937 160.079 230.937 157.804C230.937 155.529 229.751 153.684 228.288 153.684C226.826 153.684 225.64 155.529 225.64 157.804C225.64 160.079 226.826 161.924 228.288 161.924Z"
        fill="#3A3A94"
      />
      <path
        d="M269.676 252.344L262.556 252.756L262.632 254.001L269.752 253.588L269.676 252.344Z"
        fill="#151E4D"
      />
      <path
        d="M246.642 253.475L246.829 254.994C246.927 256.146 246.619 257.296 245.957 258.258L245.79 258.5L254.212 257.707L253.964 257.455C253.145 256.617 252.643 255.535 252.538 254.383L252.352 253.191L246.642 253.478V253.475Z"
        fill="#4F4FAB"
      />
      <path
        d="M248.933 273.345L248.841 272.7C248.677 271.555 248.119 270.498 247.26 269.7L247.045 269.5L255.441 268.48L255.257 268.779C254.647 269.772 254.399 270.934 254.553 272.081L254.819 273.345H248.933Z"
        fill="#4F4FAB"
      />
      <path
        d="M245.121 260.351L246.072 267.916C246.24 269.257 247.492 270.211 248.868 270.047L253.72 269.468C255.096 269.304 256.075 268.083 255.907 266.742L254.956 259.178C254.788 257.837 253.536 256.883 252.159 257.047L247.308 257.626C245.932 257.79 244.953 259.01 245.121 260.351Z"
        fill="#B6BECC"
      />
      <path
        d="M254.159 268.664C253.993 268.736 253.814 268.784 253.632 268.806L248.898 269.37C248.404 269.43 247.915 269.295 247.521 268.993C247.127 268.691 246.876 268.262 246.815 267.781L245.878 260.327C245.778 259.539 246.231 258.764 246.979 258.44C247.145 258.367 247.324 258.32 247.506 258.297L252.24 257.734C253.264 257.612 254.198 258.325 254.323 259.322L255.26 266.776C255.36 267.564 254.907 268.34 254.159 268.664Z"
        fill="#151E4D"
      />
      <path
        d="M247.324 259.045L246.495 259.995L251.084 263.795L251.912 262.845L247.324 259.045Z"
        fill="white"
      />
      <path
        d="M249.632 263.138L248.803 264.088L250.948 265.865L251.777 264.915L249.632 263.138Z"
        fill="white"
      />
      <path
        d="M224.772 270.899L223.725 270.181L225.916 267.153L230.112 264.131L230.872 265.136L226.842 268.036L224.772 270.899Z"
        fill="#151E4D"
      />
      <path
        d="M220.416 271.514L219.331 270.851L223.096 265.015L227.981 261.147L228.787 262.115L224.065 265.853L220.416 271.514Z"
        fill="#151E4D"
      />
      <path
        d="M236.361 268.595C235.035 261.612 230.053 255.936 230.004 255.882L230.971 255.066C231.186 255.308 236.23 261.046 237.62 268.37L236.361 268.597V268.595Z"
        fill="#151E4D"
      />
      <path
        d="M278.152 230.816C285.425 223.728 285.425 212.237 278.152 205.149C270.879 198.061 259.086 198.061 251.813 205.149C244.539 212.237 244.539 223.728 251.813 230.816C259.086 237.904 270.879 237.904 278.152 230.816Z"
        fill="#3A3A94"
      />
      <path
        d="M261.551 248.836C250.092 231.484 249.99 231.147 249.954 231.038L251.18 230.679C251.175 230.664 251.169 230.639 251.151 230.606C251.459 231.2 258.181 241.432 262.629 248.162L261.551 248.838V248.836Z"
        fill="white"
      />
      <g clip-path="url(#clip0_3081_105695)">
        <path
          d="M94.2769 172.763L106.325 195.748L129.154 167.312L132.374 160.572C132.802 159.838 133.977 158.328 134.519 157.679C137.098 154.587 143.867 144.897 144.914 147.483C145.784 149.649 139.756 159.047 139.756 159.047C139.756 159.047 152.966 166.486 141.202 173.618L137.982 179.354L118.602 217.323C113.628 227.704 99.3428 228.936 92.6595 219.567L70.629 188.659L94.2698 172.763H94.2769Z"
          fill="#BA757A"
        />
        <path
          d="M94.2725 172.764L103.877 191.082L87.0192 211.652L69.6271 188.317L94.2725 172.771V172.764Z"
          fill="#9B9BDE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M144.572 162.054L143.382 162.069V162.354C143.382 162.453 143.389 165.624 139.72 167.491L139.463 167.619L139.841 168.766L140.254 168.552C144.572 166.358 144.572 162.532 144.572 162.339V162.054Z"
          fill="#151E4D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M145.034 164.883L144.977 165.161C144.977 165.161 144.828 165.923 144.357 166.849C143.887 167.768 143.118 168.83 141.885 169.45L141.629 169.578L142.17 170.64L142.427 170.512C143.937 169.742 144.863 168.495 145.412 167.426C145.961 166.365 146.139 165.467 146.153 165.382L146.203 165.104L145.034 164.883Z"
          fill="#151E4D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M141.576 160.387L141.555 160.672C141.555 160.708 141.469 161.57 140.935 162.653C140.393 163.765 139.396 165.104 137.543 166.045L137.287 166.173L137.828 167.235L138.085 167.106C142.374 164.926 142.73 160.957 142.744 160.758L142.766 160.473L141.576 160.38V160.387Z"
          fill="#151E4D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M141.437 162.005C141.394 161.563 141.152 161.171 140.782 160.936C140.404 160.694 139.948 160.644 139.52 160.793L135.025 162.382C134.447 162.304 132.424 162.14 130.856 163.38C129.709 164.285 129.104 165.695 129.018 167.526L129.004 167.811L129.802 167.847L130.18 168.225L130.208 167.583C130.279 166.052 130.764 164.976 131.59 164.32C132.267 163.786 133.101 163.593 133.785 163.544C134.127 163.515 134.419 163.529 134.633 163.544C134.74 163.551 134.825 163.565 134.882 163.572C134.911 163.572 134.932 163.572 134.946 163.579C134.96 163.579 134.968 163.579 134.968 163.579L135.124 163.608L139.912 161.912C139.991 161.883 140.069 161.898 140.133 161.933C140.197 161.976 140.233 162.04 140.24 162.111C140.276 162.468 140.183 163.038 139.492 163.707C138.787 164.384 137.454 165.161 135.01 165.888L134.74 165.966L135.082 167.113L135.352 167.035C137.917 166.272 139.471 165.41 140.368 164.534C141.273 163.65 141.508 162.76 141.437 162.005Z"
          fill="#151E4D"
        />
        <path
          d="M81.684 193.611C89.5571 193.611 95.934 187.227 95.934 179.361C95.934 171.495 89.55 165.111 81.684 165.111C73.818 165.111 67.434 171.495 67.434 179.361C67.434 187.227 73.818 193.611 81.684 193.611Z"
          fill="#9B9BDE"
        />
        <path
          d="M82.219 165.104L60.046 163.479L23.053 171.666L27.8267 220.337L29.0807 247.412H95.9275L82.2118 165.111L82.219 165.104Z"
          fill="#9B9BDE"
        />
        <path
          d="M62.432 138.599C62.0259 139.276 61.6127 139.96 61.0142 140.466C58.2283 142.824 56.6252 138.699 56.7107 136.469C56.7819 134.688 57.644 132.985 58.7413 131.61C60.038 129.992 64.2062 126.579 65.5314 129.999C66.6714 132.949 63.8499 136.248 62.432 138.592V138.599Z"
          fill="#151E4D"
        />
        <path
          d="M56.9548 149.614C56.9548 149.614 60.0114 163.943 62.0278 171.595C63.4456 177.003 58.4724 178.064 58.4724 178.064C58.4724 178.064 45.7186 181.014 47.0011 172.193C47.165 171.082 47.279 169.956 47.3075 168.838C47.4144 164.783 48.2908 156.412 47.0439 152.172L56.9548 149.614Z"
          fill="#BA757A"
        />
        <path
          d="M52.6941 157.124L58.786 157.986L59.8761 162.774C59.8761 162.774 54.2758 161.798 52.7012 157.124H52.6941Z"
          fill="#151E4D"
        />
        <path
          d="M47.6561 155.571C47.6561 155.571 61.0226 160.858 65.1408 155.799C68.0692 152.201 64.3571 141.342 61.9702 135.365C60.8017 132.429 58.3507 130.192 55.3154 129.315C51.3326 128.161 45.4901 128.232 45.3689 134.346C45.1694 144.591 47.6561 155.571 47.6561 155.571Z"
          fill="#BA757A"
        />
        <path
          d="M62.3921 142.225C63.2186 143.536 64.4441 144.662 67.2727 146.764C67.8854 147.22 67.7144 148.175 66.9806 148.388L63.9667 148.673C63.1117 148.752 62.3351 148.182 62.1641 147.341L61.2734 143.095C61.2307 141.947 62.0572 141.691 62.3921 142.225Z"
          fill="#8C4D51"
        />
        <path
          d="M58.9078 142.482C58.979 143.052 58.751 143.55 58.3877 143.593C58.0314 143.636 57.6823 143.216 57.611 142.646C57.5398 142.076 57.7678 141.577 58.1312 141.534C58.4874 141.491 58.8365 141.912 58.9078 142.482Z"
          fill="#151E4D"
        />
        <path
          d="M63.8356 140.266C63.7715 140.244 63.7074 140.237 63.6361 140.244C63.2799 140.287 63.0448 140.786 63.116 141.356C63.1873 141.926 63.5364 142.353 63.8926 142.304C64.1135 142.275 64.2845 142.076 64.37 141.798C64.1919 141.278 64.0138 140.765 63.8356 140.266Z"
          fill="#151E4D"
        />
        <path
          d="M53.1642 139.361C51.896 140.252 50.6776 141.2 49.5305 142.261C48.5757 143.145 47.7421 144.171 47.1507 145.325C46.5451 146.522 46.538 147.733 46.7018 149.051C46.8657 150.369 47.222 151.645 47.4713 152.949C47.6993 154.153 47.7207 155.279 47.7848 156.49C47.7848 156.611 47.7991 156.732 47.7492 156.846C47.6993 156.953 47.5853 157.046 47.4713 157.024C47.3787 157.003 47.3146 156.932 47.2576 156.853C46.3313 155.692 45.2768 154.623 44.1226 153.69C42.9755 152.756 41.7143 152.144 40.6527 151.061C38.7788 149.144 38.2017 146.073 37.8455 143.537C37.4322 140.601 37.2398 137.587 37.8383 134.673C38.4368 131.759 39.8903 128.923 42.2843 127.106C46.082 124.228 51.3687 124.406 56.057 125.247C57.5532 125.51 59.0708 125.845 60.3818 126.615C61.6857 127.384 62.7616 128.66 62.9183 130.156C63.1606 132.514 61.13 134.516 59.0495 135.713C57.0473 136.868 55.0595 138.043 53.1713 139.361H53.1642Z"
          fill="#151E4D"
        />
        <path
          d="M49.2869 143.515C49.2869 143.515 46.3799 139.055 44.7127 141.72C43.0525 144.384 41.9411 147.427 43.9931 148.652C46.0451 149.878 48.6029 148.666 48.6029 148.666L49.2798 143.515H49.2869Z"
          fill="#BA757A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M45.4186 144.156L45.0125 145.275L47.4136 146.151L47.8197 145.033L45.4186 144.156Z"
          fill="#151E4D"
        />
        <path
          d="M48.8597 149.977C49.3727 149.279 49.2231 148.296 48.5249 147.783C47.8266 147.27 46.8433 147.42 46.3303 148.118C45.8173 148.816 45.967 149.799 46.6652 150.312C47.3635 150.825 48.3467 150.676 48.8597 149.977Z"
          fill="#F5167A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M87.2069 191.552L86.0312 191.737L94.8876 247.291L96.0633 247.106L87.2069 191.552Z"
          fill="white"
        />
        <path
          d="M34.5194 201.15L45.157 246.913L29.083 247.398L27.829 220.323C27.829 220.323 32.6526 207.213 34.5194 201.142V201.15Z"
          fill="#151E4D"
        />
        <path
          d="M40.7439 129.109C39.2833 127.164 36.7325 125.76 34.4169 126.494C32.5858 127.078 31.3389 128.874 30.9256 130.747C30.3129 133.548 31.403 136.654 33.6331 138.457C35.7564 140.174 39.5611 142.048 41.5704 139.255C43.6153 136.412 42.7104 131.716 40.751 129.109H40.7439Z"
          fill="#151E4D"
        />
        <path
          d="M95.2884 247.405L89.6383 276.275H22.307L29.09 247.405H95.2884Z"
          fill="#151E4D"
        />
        <path
          d="M29.2283 246.806L21.5333 276.874H90.1257L96.0109 246.806H29.2283ZM23.0723 275.677L30.1617 247.996H94.5646L89.1496 275.677H23.0723Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M52.3183 251.102L49.5253 256.026C47.7013 259.239 44.267 261.241 40.5691 261.241H30.473V262.431H40.5691C44.6945 262.431 48.5206 260.201 50.5584 256.617L53.3514 251.694L52.3111 251.102H52.3183Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M68.5112 258.106L66.8225 266.357L60.5525 267.889L58.472 276.41L59.6334 276.695L61.5358 268.879L67.8343 267.333L69.6797 258.348L68.5112 258.106Z"
          fill="white"
        />
        <path
          d="M107.027 194.186L102.73 199.554L103.776 200.391L108.072 195.023L107.027 194.186Z"
          fill="#151E4D"
        />
        <path
          d="M44.8864 215.333L57.655 216.177C58.9418 216.263 60.0974 215.418 60.4086 214.167L66.9312 188.65C67.3304 187.041 66.1775 185.473 64.5281 185.364L51.7595 184.519C50.4727 184.434 49.3172 185.278 49.0059 186.529L42.4833 212.046C42.0841 213.655 43.2371 215.223 44.8864 215.333Z"
          fill="#F5167A"
        />
        <path
          d="M64.9539 187.57C64.5873 187.067 64.0155 186.751 63.3899 186.71L52.3987 185.982C51.382 185.915 50.4591 186.589 50.215 187.58L49.0846 192.147L50.244 192.43L51.3745 187.864C51.4814 187.435 51.8793 187.14 52.3201 187.17L63.3113 187.897C63.5815 187.915 63.8294 188.052 63.9864 188.27C64.1434 188.487 64.2033 188.77 64.1361 189.03L62.6849 194.882L63.9633 195.202L65.2884 189.313C65.4355 188.709 65.3134 188.072 64.9397 187.569L64.9539 187.57Z"
          fill="white"
        />
        <path
          d="M62.4303 196.538L61.8014 199.076L62.9563 199.363L63.5852 196.824L62.4303 196.538Z"
          fill="white"
        />
        <path
          d="M56.5316 214.238H45.5163C44.9748 214.238 44.469 214.002 44.1198 213.582C43.7707 213.169 43.6282 212.627 43.7208 212.093L44.3336 212.2C44.2695 212.549 44.3692 212.905 44.5972 213.183C44.8252 213.454 45.1601 213.611 45.5163 213.611H56.5316C57.1158 213.611 57.6075 213.19 57.7143 212.62L58.3271 212.727C58.1703 213.596 57.4151 214.23 56.5316 214.23V214.238Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.2553 213.012C58.006 213.739 57.322 214.238 56.5311 214.238H45.5158C44.9743 214.238 44.4685 214.003 44.1193 213.582C43.8343 213.24 43.6847 212.813 43.6918 212.378C43.6918 212.285 43.7061 212.193 43.7203 212.1L44.3331 212.207C44.269 212.556 44.3687 212.912 44.5967 213.19C44.8247 213.461 45.1596 213.618 45.5158 213.618H56.5311C57.1153 213.618 57.607 213.205 57.7138 212.627L58.3266 212.734C58.3123 212.827 58.2838 212.92 58.2553 213.012ZM56.4171 214.523H56.5382C57.5571 214.523 58.4335 213.796 58.6116 212.784L58.6615 212.506L57.4858 212.3L57.436 212.578C57.3576 213.012 56.98 213.333 56.5382 213.333H45.523C45.2522 213.333 44.9957 213.212 44.8247 213.005C44.6466 212.798 44.5753 212.521 44.6252 212.257L44.6751 211.979L43.4995 211.765L43.4496 212.043C43.3356 212.656 43.5066 213.283 43.9056 213.767C44.3046 214.245 44.896 214.523 45.523 214.523H56.4171Z"
          fill="white"
        />
        <path
          d="M0.562344 219.097L10.6585 184.655L37.477 192.535L30.3733 213.233L34.57 215.421C33.2661 211.844 42.5143 208.267 42.5143 208.267L42.892 210.554C43.0202 211.352 43.5617 212.015 44.3098 212.314L58.1822 217.836L58.1323 218C57.3842 220.593 55.8381 222.88 53.7148 224.541C50.53 227.034 45.7491 228.21 41.8232 229.172L16.8928 236.169C6.68984 238.669 -2.38741 229.179 0.569469 219.097H0.562344Z"
          fill="#BA757A"
        />
        <path
          d="M30.5462 212.905C30.2968 212.848 28.0168 212.321 24.5184 212.528C21.2124 212.72 16.1537 213.639 10.8598 216.931L10.6176 217.08L10.9453 217.608L10.8812 217.65L11.2232 217.992L11.3087 217.928L11.3657 218.021L11.4868 217.943C16.5598 214.793 21.3977 213.91 24.5612 213.717C27.5109 213.546 29.5701 213.917 30.1543 214.038L30.5391 214.124L30.8241 212.969L30.5462 212.898V212.905Z"
          fill="#151E4D"
        />
        <path
          d="M56.0321 221.754C56.728 220.895 57.3391 219.973 57.8695 219.012C58.6896 217.522 59.2956 215.866 59.7434 214.209C60.2182 212.463 60.6875 210.55 60.1545 208.756C60.0283 208.321 59.6954 207.821 59.2503 207.917C58.4639 208.087 57.945 209.943 57.6697 210.573C57.1371 211.808 56.6448 213.063 56.0042 214.247C54.6959 216.654 52.4259 218.53 51.614 221.143C51.4981 221.508 51.4187 221.921 51.5778 222.275C51.6772 222.49 51.8489 222.651 52.0207 222.812C52.7006 223.454 53.4896 224.19 54.3968 223.569C55.0726 223.109 55.5261 222.389 56.0382 221.763L56.0321 221.754Z"
          fill="#BA757A"
        />
        <path
          d="M53.7827 217.613C54.5289 216.753 55.1834 215.83 55.75 214.866C57.0337 212.686 58.0263 210.17 58.3004 207.648C58.3879 206.868 58.7785 203.463 57.2306 203.778C56.3716 203.953 55.7615 205.947 55.4429 206.629C54.9051 207.798 54.4005 208.986 53.7487 210.097C52.3477 212.498 49.9185 214.381 49.0491 216.993C48.9252 217.364 48.8397 217.769 49.0059 218.124C49.1052 218.339 49.2982 218.503 49.477 218.664C50.2063 219.313 51.0547 220.036 52.0263 219.417C52.7526 218.958 53.2352 218.234 53.7836 217.605L53.7827 217.613Z"
          fill="#BA757A"
        />
        <path
          d="M51.3503 214.3C52.0966 213.44 52.751 212.518 53.3177 211.554C54.46 209.613 55.2531 207.494 55.7227 205.322C55.8888 204.547 56.5385 200.112 54.7983 200.466C53.9765 200.631 53.4203 202.445 53.1128 203.1C52.5359 204.343 52.0063 205.607 51.3144 206.798C49.9134 209.199 47.4852 211.075 46.6148 213.694C46.4919 214.059 46.4054 214.471 46.5716 214.825C46.6709 215.04 46.8639 215.204 47.0427 215.366C47.772 216.015 48.6204 216.738 49.5911 216.126C50.3173 215.666 50.7999 214.942 51.3484 214.314L51.3503 214.3Z"
          fill="#BA757A"
        />
        <path
          d="M47.9049 213.962C48.5987 213.066 49.2006 212.107 49.7077 211.106C50.7279 209.113 51.4041 206.955 51.7496 204.745C51.8695 203.992 52.3054 199.491 50.5433 199.95C49.7367 200.16 49.2663 202.03 49.0082 202.692C48.5069 203.96 48.053 205.249 47.4367 206.465C46.176 208.943 43.858 210.956 43.1399 213.619C43.0372 213.993 42.9789 214.409 43.1692 214.745C43.2847 214.948 43.4786 215.105 43.6725 215.262C44.4369 215.865 45.3276 216.544 46.2567 215.868C46.9536 215.361 47.3959 214.617 47.9049 213.962Z"
          fill="#BA757A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.8695 207.943L58.8949 207.659L57.7076 207.557L57.6691 207.832C57.6691 207.832 57.347 211.212 54.555 215.634L54.3995 215.871L55.4039 216.508L55.5594 216.271C58.5149 211.606 58.8518 208.12 58.8695 207.943Z"
          fill="#151E4D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M56.3762 204.99L56.3946 204.705L55.2034 204.631L55.185 204.917C55.1801 204.952 54.9233 208.276 51.3211 213.398L51.1586 213.634L51.8986 214.155L52.0341 213.958L52.2301 214.151L52.5438 213.914L52.459 213.852C56.1121 208.572 56.3637 205.182 56.3762 204.99Z"
          fill="#151E4D"
        />
        <path
          d="M52.5042 203.045L52.4571 202.765L51.2706 202.965L51.3238 203.253C51.3259 203.29 51.3773 203.642 51.3407 204.263L51.6048 203.199L51.3397 204.27C51.2919 205.177 51.0613 206.67 50.2816 208.59L49.911 210.106C49.9601 210.012 50.0022 209.918 50.0442 209.823C49.9951 209.917 49.9601 210.012 49.911 210.106L50.2816 208.59C49.8763 209.583 49.3332 210.687 48.5819 211.891L48.4324 212.137L49.4448 212.768L49.5943 212.522C53.0833 206.924 52.532 203.257 52.4971 203.044L52.5042 203.045Z"
          fill="#151E4D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M56.705 216.899C56.5856 216.724 54.3211 213.681 47.2109 210.663L46.9456 210.554L46.4751 211.654L46.7404 211.763C53.4965 214.637 55.6931 217.549 55.7366 217.598L56.1514 218.182L56.2334 217.596L56.2977 217.547L56.8659 217.138L56.704 216.906L56.705 216.899Z"
          fill="#151E4D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M43.9774 211.117C43.9774 211.117 43.949 211.063 43.9277 211.009C43.8871 210.888 43.8392 210.716 43.8054 210.496C43.7296 210.061 43.6867 208.781 43.6942 208.214L43.6984 207.926L42.5064 207.911L42.5021 208.198C42.4952 208.607 42.5052 210.019 42.6158 210.667C42.6711 210.991 42.7557 211.313 42.8844 211.575C43.0131 211.838 43.2002 212.094 43.4867 212.206L43.8276 212.341L43.8731 212.016L44.1953 211.205L43.9703 211.116L43.9774 211.117Z"
          fill="#151E4D"
        />
        <path
          d="M24.9066 200.066C32.7797 200.066 39.1566 193.689 39.1566 185.816C39.1566 177.943 32.7726 171.566 24.9066 171.566C17.0406 171.566 10.6566 177.95 10.6566 185.816C10.6566 193.682 17.0406 200.066 24.9066 200.066Z"
          fill="#9B9BDE"
        />
        <path
          d="M38.659 189.571L31.876 209.058L3.7821 208.11L11.071 182.389L38.659 189.578V189.571Z"
          fill="#9B9BDE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M146.42 166.094C146.085 164.107 144.774 161.314 140.599 158.841C141.24 157.822 142.551 155.692 143.67 153.497C144.276 152.3 144.831 151.075 145.188 150.006C145.366 149.472 145.494 148.959 145.551 148.51C145.608 148.061 145.601 147.641 145.487 147.299L145.394 147.028L144.261 147.406L144.354 147.676C144.411 147.847 144.418 148.104 144.368 148.453C144.311 148.802 144.204 149.215 144.048 149.678C143.727 150.612 143.228 151.716 142.658 152.849C141.511 155.115 140.079 157.473 139.267 158.72L138.918 159.262L139.481 159.568C142.851 161.42 144.81 163.743 145.252 166.251C145.572 168.089 144.974 169.45 144.945 169.514V169.522C144.924 169.564 144.603 170.191 143.976 170.932C143.321 171.702 142.338 172.571 141.027 173.041L140.756 173.134L141.155 174.26L141.426 174.167C144.539 173.063 145.964 170.17 146.028 170.035C146.071 169.942 146.826 168.325 146.449 166.08L146.42 166.094Z"
          fill="#151E4D"
        />
      </g>
      <g filter="url(#filter0_d_3081_105695)">
        <g clip-path="url(#clip1_3081_105695)">
          <rect
            x="119.7"
            y="34"
            width="318.44"
            height="107.16"
            rx="3.8"
            fill="white"
          />
          <path
            d="M119.7 36.28C119.7 35.0208 120.721 34 121.98 34H184.68V59.08H119.7V36.28Z"
            fill="#F5F5FC"
          />
          <path
            d="M133.382 43.5655V48.54H132.692L130.163 44.8917H130.117V48.54H129.366V43.5655H130.061L132.592 47.2187H132.638V43.5655H133.382ZM134.476 48.54V43.5655H136.25C136.635 43.5655 136.955 43.6319 137.209 43.7647C137.465 43.8975 137.656 44.0812 137.782 44.316C137.909 44.5492 137.972 44.8188 137.972 45.1249C137.972 45.4293 137.908 45.6973 137.78 45.9289C137.654 46.1588 137.462 46.3378 137.207 46.4657C136.952 46.5936 136.633 46.6576 136.247 46.6576H134.904V46.0115H136.179C136.422 46.0115 136.62 45.9767 136.772 45.907C136.926 45.8374 137.038 45.7362 137.109 45.6034C137.181 45.4706 137.216 45.3111 137.216 45.1249C137.216 44.9371 137.18 44.7743 137.107 44.6367C137.036 44.499 136.923 44.3938 136.769 44.3209C136.617 44.2464 136.417 44.2092 136.169 44.2092H135.227V48.54H134.476ZM136.932 46.2957L138.161 48.54H137.306L136.101 46.2957H136.932ZM139.636 43.5655V48.54H138.885V43.5655H139.636ZM144.86 45.1832H144.102C144.073 45.0213 144.019 44.8788 143.94 44.7557C143.86 44.6326 143.763 44.5282 143.648 44.4424C143.533 44.3565 143.405 44.2918 143.262 44.248C143.121 44.2043 142.971 44.1825 142.813 44.1825C142.526 44.1825 142.269 44.2545 142.043 44.3986C141.818 44.5428 141.639 44.7541 141.508 45.0326C141.379 45.3111 141.314 45.6512 141.314 46.0528C141.314 46.4576 141.379 46.7993 141.508 47.0778C141.639 47.3563 141.818 47.5668 142.045 47.7093C142.272 47.8518 142.527 47.9231 142.81 47.9231C142.967 47.9231 143.116 47.902 143.257 47.8599C143.4 47.8162 143.528 47.7522 143.643 47.668C143.758 47.5838 143.856 47.481 143.935 47.3596C144.016 47.2365 144.072 47.0956 144.102 46.9369L144.86 46.9393C144.82 47.1839 144.741 47.4089 144.625 47.6146C144.51 47.8186 144.362 47.9951 144.18 48.1441C144 48.2915 143.795 48.4056 143.563 48.4866C143.332 48.5676 143.079 48.6081 142.805 48.6081C142.375 48.6081 141.991 48.506 141.654 48.302C141.317 48.0963 141.052 47.8024 140.857 47.4203C140.665 47.0381 140.568 46.5823 140.568 46.0528C140.568 45.5216 140.665 45.0658 140.86 44.6853C141.054 44.3031 141.32 44.01 141.656 43.806C141.993 43.6003 142.376 43.4975 142.805 43.4975C143.069 43.4975 143.315 43.5355 143.544 43.6116C143.774 43.6861 143.98 43.7962 144.163 43.942C144.346 44.0861 144.498 44.2626 144.617 44.4715C144.737 44.6788 144.818 44.916 144.86 45.1832ZM147.595 43.3323L145.992 49.2882H145.343L146.946 43.3323H147.595ZM148.27 48.54V43.5655H151.355V44.2116H149.021V45.7273H151.134V46.371H149.021V48.54H148.27ZM153.028 43.5655V48.54H152.278V43.5655H153.028ZM158.136 43.5655V48.54H157.447L154.918 44.8917H154.872V48.54H154.121V43.5655H154.816L157.347 47.2187H157.393V43.5655H158.136Z"
            fill="#3C4764"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M184.68 59.08L119.7 59.08L119.7 58.51L184.68 58.51L184.68 59.08Z"
            fill="#E9EAEE"
          />
          <rect
            x="128.25"
            y="69.1499"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M184.68 86.44L119.7 86.44L119.7 85.87L184.68 85.87L184.68 86.44Z"
            fill="#E9EAEE"
          />
          <rect
            x="128.25"
            y="96.5099"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M184.68 113.8L119.7 113.8L119.7 113.23L184.68 113.23L184.68 113.8Z"
            fill="#E9EAEE"
          />
          <rect
            x="128.25"
            y="123.87"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
          <rect
            width="53.39"
            height="25.08"
            transform="translate(184.68 34)"
            fill="#F5F5FC"
          />
          <path
            d="M194.346 48.54V43.5655H195.097V47.8939H197.351V48.54H194.346ZM202.335 46.0528C202.335 46.5839 202.238 47.0406 202.043 47.4227C201.849 47.8032 201.583 48.0963 201.244 48.302C200.907 48.506 200.524 48.6081 200.095 48.6081C199.664 48.6081 199.28 48.506 198.941 48.302C198.605 48.0963 198.339 47.8024 198.145 47.4203C197.95 47.0381 197.853 46.5823 197.853 46.0528C197.853 45.5216 197.95 45.0658 198.145 44.6853C198.339 44.3031 198.605 44.01 198.941 43.806C199.28 43.6003 199.664 43.4975 200.095 43.4975C200.524 43.4975 200.907 43.6003 201.244 43.806C201.583 44.01 201.849 44.3031 202.043 44.6853C202.238 45.0658 202.335 45.5216 202.335 46.0528ZM201.591 46.0528C201.591 45.6479 201.526 45.3071 201.395 45.0302C201.265 44.7516 201.087 44.5411 200.86 44.3986C200.635 44.2545 200.38 44.1825 200.095 44.1825C199.809 44.1825 199.553 44.2545 199.328 44.3986C199.103 44.5411 198.924 44.7516 198.793 45.0302C198.664 45.3071 198.599 45.6479 198.599 46.0528C198.599 46.4576 198.664 46.7993 198.793 47.0778C198.924 47.3547 199.103 47.5652 199.328 47.7093C199.553 47.8518 199.809 47.9231 200.095 47.9231C200.38 47.9231 200.635 47.8518 200.86 47.7093C201.087 47.5652 201.265 47.3547 201.395 47.0778C201.526 46.7993 201.591 46.4576 201.591 46.0528ZM207.402 45.1832H206.644C206.615 45.0213 206.561 44.8788 206.482 44.7557C206.402 44.6326 206.305 44.5282 206.19 44.4424C206.075 44.3565 205.946 44.2918 205.804 44.248C205.663 44.2043 205.513 44.1825 205.355 44.1825C205.068 44.1825 204.811 44.2545 204.585 44.3986C204.36 44.5428 204.181 44.7541 204.05 45.0326C203.921 45.3111 203.856 45.6512 203.856 46.0528C203.856 46.4576 203.921 46.7993 204.05 47.0778C204.181 47.3563 204.36 47.5668 204.587 47.7093C204.814 47.8518 205.069 47.9231 205.352 47.9231C205.509 47.9231 205.658 47.902 205.799 47.8599C205.942 47.8162 206.07 47.7522 206.185 47.668C206.3 47.5838 206.397 47.481 206.477 47.3596C206.558 47.2365 206.614 47.0956 206.644 46.9369L207.402 46.9393C207.362 47.1839 207.283 47.4089 207.167 47.6146C207.052 47.8186 206.903 47.9951 206.722 48.1441C206.542 48.2915 206.337 48.4056 206.105 48.4866C205.874 48.5676 205.621 48.6081 205.347 48.6081C204.917 48.6081 204.533 48.506 204.196 48.302C203.859 48.0963 203.594 47.8024 203.399 47.4203C203.207 47.0381 203.11 46.5823 203.11 46.0528C203.11 45.5216 203.207 45.0658 203.402 44.6853C203.596 44.3031 203.862 44.01 204.198 43.806C204.535 43.6003 204.918 43.4975 205.347 43.4975C205.611 43.4975 205.857 43.5355 206.086 43.6116C206.316 43.6861 206.522 43.7962 206.705 43.942C206.888 44.0861 207.039 44.2626 207.159 44.4715C207.279 44.6788 207.36 44.916 207.402 45.1832ZM208.687 48.54H207.89L209.681 43.5655H210.548L212.338 48.54H211.541L210.135 44.4691H210.096L208.687 48.54ZM208.821 46.592H211.405V47.2235H208.821V46.592ZM212.223 44.2116V43.5655H216.073V44.2116H214.521V48.54H213.773V44.2116H212.223ZM217.674 43.5655V48.54H216.924V43.5655H217.674ZM223.089 46.0528C223.089 46.5839 222.991 47.0406 222.797 47.4227C222.603 47.8032 222.336 48.0963 221.998 48.302C221.661 48.506 221.278 48.6081 220.849 48.6081C220.418 48.6081 220.034 48.506 219.695 48.302C219.358 48.0963 219.093 47.8024 218.899 47.4203C218.704 47.0381 218.607 46.5823 218.607 46.0528C218.607 45.5216 218.704 45.0658 218.899 44.6853C219.093 44.3031 219.358 44.01 219.695 43.806C220.034 43.6003 220.418 43.4975 220.849 43.4975C221.278 43.4975 221.661 43.6003 221.998 43.806C222.336 44.01 222.603 44.3031 222.797 44.6853C222.991 45.0658 223.089 45.5216 223.089 46.0528ZM222.345 46.0528C222.345 45.6479 222.28 45.3071 222.149 45.0302C222.019 44.7516 221.841 44.5411 221.614 44.3986C221.389 44.2545 221.134 44.1825 220.849 44.1825C220.562 44.1825 220.307 44.2545 220.081 44.3986C219.856 44.5411 219.678 44.7516 219.547 45.0302C219.418 45.3071 219.353 45.6479 219.353 46.0528C219.353 46.4576 219.418 46.7993 219.547 47.0778C219.678 47.3547 219.856 47.5652 220.081 47.7093C220.307 47.8518 220.562 47.9231 220.849 47.9231C221.134 47.9231 221.389 47.8518 221.614 47.7093C221.841 47.5652 222.019 47.3547 222.149 47.0778C222.28 46.7993 222.345 46.4576 222.345 46.0528ZM228.039 43.5655V48.54H227.35L224.821 44.8917H224.775V48.54H224.024V43.5655H224.719L227.25 47.2187H227.296V43.5655H228.039Z"
            fill="#3C4764"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M238.07 59.08L184.68 59.08L184.68 58.51L238.07 58.51L238.07 59.08Z"
            fill="#E9EAEE"
          />
          <rect
            x="187.53"
            y="69.1499"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M238.07 86.44L184.68 86.44L184.68 85.87L238.07 85.87L238.07 86.44Z"
            fill="#E9EAEE"
          />
          <rect
            x="187.53"
            y="96.5099"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M238.07 113.8L184.68 113.8L184.68 113.23L238.07 113.23L238.07 113.8Z"
            fill="#E9EAEE"
          />
          <rect
            x="187.53"
            y="123.87"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
          <rect
            width="41.99"
            height="25.08"
            transform="translate(238.07 34)"
            fill="#F5F5FC"
          />
          <path
            d="M248.487 43.5655V48.54H247.736V43.5655H248.487ZM249.335 44.2116V43.5655H253.185V44.2116H251.633V48.54H250.884V44.2116H249.335ZM254.035 48.54V43.5655H257.154V44.2116H254.786V45.7273H256.991V46.371H254.786V47.8939H257.183V48.54H254.035ZM258.157 43.5655H259.068L260.651 47.4324H260.71L262.293 43.5655H263.204V48.54H262.49V44.9403H262.444L260.977 48.5328H260.384L258.917 44.9379H258.871V48.54H258.157V43.5655ZM268.576 43.5655V48.54H267.823V44.3185H267.794L266.604 45.0957V44.3768L267.845 43.5655H268.576Z"
            fill="#3C4764"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M280.06 59.08L238.07 59.08L238.07 58.51L280.06 58.51L280.06 59.08Z"
            fill="#E9EAEE"
          />
          <path
            d="M258.115 74.4633L256.551 72.8992L255.879 73.5708L258.115 75.8066L262.726 71.1958L262.054 70.5242L258.115 74.4633Z"
            fill="#272D41"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M280.06 86.44L238.07 86.44L238.07 85.87L280.06 85.87L280.06 86.44Z"
            fill="#E9EAEE"
          />
          <path
            d="M258.115 101.823L256.551 100.259L255.879 100.931L258.115 103.167L262.726 98.5558L262.054 97.8842L258.115 101.823Z"
            fill="#272D41"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M280.06 113.8L238.07 113.8L238.07 113.23L280.06 113.23L280.06 113.8Z"
            fill="#E9EAEE"
          />
          <path
            d="M258.115 129.183L256.551 127.619L255.879 128.291L258.115 130.527L262.726 125.916L262.054 125.244L258.115 129.183Z"
            fill="#272D41"
          />
          <rect
            width="41.99"
            height="25.08"
            transform="translate(280.06 34)"
            fill="#F5F5FC"
          />
          <path
            d="M290.477 43.5655V48.54H289.726V43.5655H290.477ZM291.325 44.2116V43.5655H295.175V44.2116H293.623V48.54H292.874V44.2116H291.325ZM296.025 48.54V43.5655H299.144V44.2116H296.776V45.7273H298.981V46.371H296.776V47.8939H299.173V48.54H296.025ZM300.147 43.5655H301.058L302.641 47.4324H302.7L304.283 43.5655H305.194V48.54H304.48V44.9403H304.434L302.967 48.5328H302.374L300.907 44.9379H300.861V48.54H300.147V43.5655ZM308.183 48.54V47.9959L309.866 46.2519C310.046 46.0625 310.194 45.8965 310.311 45.754C310.429 45.6099 310.517 45.4731 310.576 45.3435C310.634 45.214 310.663 45.0763 310.663 44.9306C310.663 44.7654 310.624 44.6229 310.546 44.5031C310.469 44.3816 310.363 44.2885 310.228 44.2237C310.094 44.1574 309.942 44.1242 309.774 44.1242C309.596 44.1242 309.44 44.1606 309.308 44.2335C309.175 44.3063 309.073 44.4092 309.002 44.5419C308.93 44.6747 308.895 44.8302 308.895 45.0083H308.178C308.178 44.7055 308.248 44.4407 308.387 44.214C308.526 43.9873 308.717 43.8116 308.96 43.6869C309.203 43.5606 309.479 43.4975 309.789 43.4975C310.101 43.4975 310.376 43.5598 310.614 43.6845C310.854 43.8076 311.041 43.976 311.176 44.1897C311.31 44.4019 311.377 44.6415 311.377 44.9087C311.377 45.0933 311.342 45.2739 311.273 45.4504C311.205 45.6269 311.086 45.8236 310.916 46.0406C310.746 46.256 310.509 46.5175 310.206 46.8252L309.218 47.8599V47.8964H311.457V48.54H308.183Z"
            fill="#3C4764"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M322.05 59.08L280.06 59.08L280.06 58.51L322.05 58.51L322.05 59.08Z"
            fill="#E9EAEE"
          />
          <path
            d="M300.105 74.4633L298.541 72.8992L297.869 73.5708L300.105 75.8066L304.716 71.1958L304.044 70.5242L300.105 74.4633Z"
            fill="#272D41"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M322.05 86.44L280.06 86.44L280.06 85.87L322.05 85.87L322.05 86.44Z"
            fill="#E9EAEE"
          />
          <path
            d="M300.105 101.823L298.541 100.259L297.869 100.931L300.105 103.167L304.716 98.5558L304.044 97.8842L300.105 101.823Z"
            fill="#272D41"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M322.05 113.8L280.06 113.8L280.06 113.23L322.05 113.23L322.05 113.8Z"
            fill="#E9EAEE"
          />
          <path
            d="M300.105 129.183L298.541 127.619L297.869 128.291L300.105 130.527L304.716 125.916L304.044 125.244L300.105 129.183Z"
            fill="#272D41"
          />
          <rect
            width="41.99"
            height="25.08"
            transform="translate(322.05 34)"
            fill="#F5F5FC"
          />
          <path
            d="M332.467 43.5655V48.54H331.716V43.5655H332.467ZM333.315 44.2116V43.5655H337.165V44.2116H335.613V48.54H334.864V44.2116H333.315ZM338.015 48.54V43.5655H341.134V44.2116H338.766V45.7273H340.971V46.371H338.766V47.8939H341.163V48.54H338.015ZM342.137 43.5655H343.048L344.631 47.4324H344.69L346.273 43.5655H347.184V48.54H346.47V44.9403H346.424L344.957 48.5328H344.364L342.897 44.9379H342.851V48.54H342.137V43.5655ZM351.803 48.6081C351.469 48.6081 351.171 48.5506 350.909 48.4356C350.648 48.3206 350.442 48.1611 350.29 47.9571C350.139 47.7514 350.058 47.5134 350.047 47.243H350.809C350.819 47.3903 350.869 47.5182 350.958 47.6267C351.048 47.7336 351.166 47.8162 351.312 47.8745C351.458 47.9328 351.62 47.9619 351.798 47.9619C351.994 47.9619 352.167 47.9279 352.318 47.8599C352.47 47.7919 352.589 47.6972 352.675 47.5757C352.761 47.4527 352.804 47.311 352.804 47.1507C352.804 46.9839 352.761 46.8373 352.675 46.711C352.591 46.5831 352.467 46.4827 352.303 46.4098C352.141 46.337 351.945 46.3005 351.715 46.3005H351.295V45.6884H351.715C351.9 45.6884 352.062 45.6552 352.201 45.5888C352.342 45.5224 352.452 45.4301 352.532 45.3119C352.611 45.1921 352.651 45.052 352.651 44.8917C352.651 44.7379 352.616 44.6043 352.546 44.4909C352.478 44.376 352.381 44.2861 352.255 44.2213C352.13 44.1565 351.983 44.1242 351.813 44.1242C351.651 44.1242 351.499 44.1541 351.358 44.214C351.219 44.2723 351.106 44.3565 351.018 44.4666C350.931 44.5751 350.884 44.7055 350.877 44.8577H350.151C350.159 44.5889 350.239 44.3525 350.389 44.1484C350.541 43.9444 350.742 43.7849 350.992 43.6699C351.241 43.555 351.518 43.4975 351.822 43.4975C352.141 43.4975 352.417 43.5598 352.648 43.6845C352.881 43.8076 353.061 43.9719 353.187 44.1776C353.315 44.3832 353.378 44.6083 353.377 44.8529C353.378 45.1314 353.301 45.3678 353.144 45.5621C352.988 45.7564 352.781 45.8868 352.522 45.9532V45.992C352.852 46.0422 353.108 46.1734 353.289 46.3855C353.472 46.5977 353.563 46.8608 353.561 47.175C353.563 47.4486 353.487 47.6939 353.333 47.9109C353.181 48.1279 352.973 48.2988 352.709 48.4234C352.445 48.5465 352.143 48.6081 351.803 48.6081Z"
            fill="#3C4764"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M364.04 59.08L322.05 59.08L322.05 58.51L364.04 58.51L364.04 59.08Z"
            fill="#E9EAEE"
          />
          <path
            d="M342.095 74.4633L340.531 72.8992L339.859 73.5708L342.095 75.8066L346.706 71.1958L346.034 70.5242L342.095 74.4633Z"
            fill="#272D41"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M364.04 86.44L322.05 86.44L322.05 85.87L364.04 85.87L364.04 86.44Z"
            fill="#E9EAEE"
          />
          <path
            d="M342.095 101.823L340.531 100.259L339.859 100.931L342.095 103.167L346.706 98.5558L346.034 97.8842L342.095 101.823Z"
            fill="#272D41"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M364.04 113.8L322.05 113.8L322.05 113.23L364.04 113.23L364.04 113.8Z"
            fill="#E9EAEE"
          />
          <path
            d="M342.095 129.183L340.531 127.619L339.859 128.291L342.095 130.527L346.706 125.916L346.034 125.244L342.095 129.183Z"
            fill="#272D41"
          />
          <rect
            width="74.1"
            height="25.08"
            transform="translate(364.04 34)"
            fill="#F5F5FC"
          />
          <path
            d="M373.707 48.54V43.5655H374.457V47.8939H376.711V48.54H373.707ZM378.242 48.54H377.445L379.235 43.5655H380.102L381.892 48.54H381.096L379.689 44.4691H379.65L378.242 48.54ZM378.375 46.592H380.96V47.2235H378.375V46.592ZM385.284 44.8723C385.258 44.6423 385.151 44.4642 384.963 44.3379C384.775 44.21 384.539 44.146 384.254 44.146C384.05 44.146 383.873 44.1784 383.724 44.2432C383.575 44.3063 383.46 44.3938 383.377 44.5055C383.296 44.6156 383.256 44.7411 383.256 44.882C383.256 45.0002 383.283 45.1022 383.338 45.1881C383.395 45.2739 383.469 45.3459 383.559 45.4042C383.652 45.4609 383.75 45.5087 383.856 45.5475C383.961 45.5848 384.062 45.6156 384.159 45.6398L384.645 45.7661C384.804 45.805 384.966 45.8576 385.133 45.924C385.3 45.9904 385.455 46.0779 385.597 46.1864C385.74 46.2949 385.855 46.4293 385.942 46.5896C386.031 46.7499 386.076 46.9418 386.076 47.1652C386.076 47.447 386.003 47.6972 385.857 47.9158C385.713 48.1344 385.503 48.3069 385.228 48.4332C384.954 48.5595 384.623 48.6226 384.234 48.6226C383.862 48.6226 383.54 48.5635 383.268 48.4453C382.996 48.3271 382.783 48.1595 382.629 47.9425C382.475 47.7239 382.39 47.4648 382.374 47.1652H383.127C383.141 47.345 383.2 47.4948 383.302 47.6146C383.405 47.7328 383.537 47.8211 383.698 47.8794C383.86 47.936 384.037 47.9644 384.23 47.9644C384.442 47.9644 384.63 47.9312 384.796 47.8648C384.962 47.7968 385.094 47.7029 385.189 47.583C385.285 47.4616 385.332 47.3199 385.332 47.158C385.332 47.0106 385.29 46.89 385.206 46.796C385.123 46.7021 385.011 46.6244 384.868 46.5629C384.728 46.5013 384.568 46.4471 384.39 46.4001L383.802 46.2398C383.404 46.1313 383.088 45.9718 382.855 45.7613C382.623 45.5508 382.507 45.2723 382.507 44.9257C382.507 44.6391 382.585 44.3889 382.741 44.1752C382.896 43.9614 383.107 43.7954 383.372 43.6772C383.638 43.5574 383.937 43.4975 384.271 43.4975C384.608 43.4975 384.905 43.5566 385.162 43.6748C385.421 43.793 385.625 43.9557 385.774 44.163C385.923 44.3687 386.001 44.6051 386.008 44.8723H385.284ZM386.727 44.2116V43.5655H390.577V44.2116H389.025V48.54H388.277V44.2116H386.727ZM393.238 43.5655H394.149L395.733 47.4324H395.791L397.375 43.5655H398.285V48.54H397.571V44.9403H397.525L396.058 48.5328H395.465L393.998 44.9379H393.952V48.54H393.238V43.5655ZM403.698 46.0528C403.698 46.5839 403.601 47.0406 403.406 47.4227C403.212 47.8032 402.946 48.0963 402.607 48.302C402.27 48.506 401.887 48.6081 401.458 48.6081C401.028 48.6081 400.643 48.506 400.305 48.302C399.968 48.0963 399.702 47.8024 399.508 47.4203C399.314 47.0381 399.216 46.5823 399.216 46.0528C399.216 45.5216 399.314 45.0658 399.508 44.6853C399.702 44.3031 399.968 44.01 400.305 43.806C400.643 43.6003 401.028 43.4975 401.458 43.4975C401.887 43.4975 402.27 43.6003 402.607 43.806C402.946 44.01 403.212 44.3031 403.406 44.6853C403.601 45.0658 403.698 45.5216 403.698 46.0528ZM402.955 46.0528C402.955 45.6479 402.889 45.3071 402.758 45.0302C402.628 44.7516 402.45 44.5411 402.223 44.3986C401.998 44.2545 401.743 44.1825 401.458 44.1825C401.172 44.1825 400.916 44.2545 400.691 44.3986C400.466 44.5411 400.288 44.7516 400.156 45.0302C400.027 45.3071 399.962 45.6479 399.962 46.0528C399.962 46.4576 400.027 46.7993 400.156 47.0778C400.288 47.3547 400.466 47.5652 400.691 47.7093C400.916 47.8518 401.172 47.9231 401.458 47.9231C401.743 47.9231 401.998 47.8518 402.223 47.7093C402.45 47.5652 402.628 47.3547 402.758 47.0778C402.889 46.7993 402.955 46.4576 402.955 46.0528ZM406.244 48.54H404.634V43.5655H406.295C406.782 43.5655 407.201 43.6651 407.551 43.8643C407.901 44.0618 408.169 44.346 408.355 44.7168C408.543 45.086 408.637 45.5289 408.637 46.0455C408.637 46.5637 408.542 47.009 408.352 47.3814C408.165 47.7539 407.893 48.0405 407.536 48.2413C407.18 48.4405 406.749 48.54 406.244 48.54ZM405.384 47.8842H406.203C406.582 47.8842 406.897 47.813 407.148 47.6705C407.399 47.5263 407.586 47.3183 407.711 47.0462C407.836 46.7726 407.898 46.439 407.898 46.0455C407.898 45.6552 407.836 45.3241 407.711 45.052C407.588 44.78 407.404 44.5735 407.16 44.4326C406.915 44.2918 406.612 44.2213 406.249 44.2213H405.384V47.8842ZM410.32 43.5655V48.54H409.57V43.5655H410.32ZM411.414 48.54V43.5655H414.498V44.2116H412.164V45.7273H414.277V46.371H412.164V48.54H411.414ZM416.172 43.5655V48.54H415.421V43.5655H416.172ZM417.265 48.54V43.5655H420.384V44.2116H418.015V45.7273H420.221V46.371H418.015V47.8939H420.413V48.54H417.265ZM422.997 48.54H421.386V43.5655H423.048C423.535 43.5655 423.954 43.6651 424.303 43.8643C424.653 44.0618 424.921 44.346 425.107 44.7168C425.295 45.086 425.389 45.5289 425.389 46.0455C425.389 46.5637 425.295 47.009 425.105 47.3814C424.917 47.7539 424.645 48.0405 424.289 48.2413C423.933 48.4405 423.502 48.54 422.997 48.54ZM422.137 47.8842H422.955C423.334 47.8842 423.649 47.813 423.9 47.6705C424.151 47.5263 424.339 47.3183 424.464 47.0462C424.588 46.7726 424.651 46.439 424.651 46.0455C424.651 45.6552 424.588 45.3241 424.464 45.052C424.341 44.78 424.157 44.5735 423.912 44.4326C423.668 44.2918 423.364 44.2213 423.002 44.2213H422.137V47.8842Z"
            fill="#3C4764"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M462.65 59.08L364.04 59.08L364.04 58.51L462.65 58.51L462.65 59.08Z"
            fill="#E9EAEE"
          />
          <rect
            x="377.34"
            y="69.1499"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M462.65 86.6301L364.04 86.6301L364.04 86.0601L462.65 86.0601L462.65 86.6301Z"
            fill="#E9EAEE"
          />
          <rect
            x="377.34"
            y="96.7"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M462.65 114.18L364.04 114.18L364.04 113.61L462.65 113.61L462.65 114.18Z"
            fill="#E9EAEE"
          />
          <rect
            x="377.34"
            y="124.25"
            width="47.88"
            height="7.22"
            rx="3.61"
            fill="#F8F9F9"
          />
        </g>
        <rect
          x="119.415"
          y="33.715"
          width="319.01"
          height="107.73"
          rx="4.085"
          stroke="#E9EAEE"
          stroke-width="0.57"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3081_105695"
          x="107.73"
          y="22.0301"
          width="342.38"
          height="131.1"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5.7" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0 0.74902 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3081_105695"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3081_105695"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3081_105695">
          <rect
            width="158.196"
            height="172.197"
            fill="white"
            transform="translate(0 104.669)"
          />
        </clipPath>
        <clipPath id="clip1_3081_105695">
          <rect
            x="119.7"
            y="34"
            width="318.44"
            height="107.16"
            rx="3.8"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
)
